/**
 * Builds a PDF URL with page navigation.
 * 
 * For PDFs, this adds #page=N to navigate to the specific page.
 * 
 * @param baseUrl - The base URL of the PDF
 * @param page - The page number to navigate to (optional)
 * @returns The enhanced URL with page navigation
 */
export function buildPdfUrlWithPage(
    baseUrl: string,
    page?: number
): string {
    if (!baseUrl) return baseUrl;

    try {
        const url = new URL(baseUrl);

        // Add page parameter if provided
        if (page) {
            url.hash = `page=${page}`;
        }

        return url.toString();
    } catch (error) {
        // If URL parsing fails, return original URL
        console.error('Failed to parse URL:', error);
        return baseUrl;
    }
}
